import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import { EnrollmentActionTypeEnum } from '../../../../lib/types/enums/enrollment/enrollment-action-type.enum'

export const enrollmentActionColorMapping: Record<EnrollmentActionTypeEnum, TailwindColor> = {
  [EnrollmentActionTypeEnum.CREATE_ENROLLMENT_VIA_LEC]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.CREATE_ENROLLMENT_VIA_INTERNET]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.DIFFUSE_ENROLLMENT_INFORMATION]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.SEND_PROPOSAL]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.SEND_CERTIFICATE]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.SEND_PAYMENT_LINK]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.CONFIRM_REGISTRATION]: tailwindColors.green.DEFAULT,
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT]: tailwindColors.red.DEFAULT,
  [EnrollmentActionTypeEnum.UPDATE_ENROLLMENT]: tailwindColors.green.DEFAULT,
  [EnrollmentActionTypeEnum.REFUND_ENROLLMENT]: tailwindColors.red.DEFAULT,
  [EnrollmentActionTypeEnum.ADD_TARIFF_ADJUSTMENT]: tailwindColors.blue.DEFAULT,
  [EnrollmentActionTypeEnum.ADD_REPATRIATION_INSURANCE]: tailwindColors.blue.DEFAULT,
  [EnrollmentActionTypeEnum.REMOVE_REPATRIATION_INSURANCE]: tailwindColors.red.DEFAULT,
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_RAD_PASSED]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_DIFFUSION_DEADLINE_PASSED]:
    tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_TRIP_FOLDER_LOCKED]: tailwindColors.black.DEFAULT,
  [EnrollmentActionTypeEnum.SEND_CSE_VALIDATION_REQUEST]: tailwindColors.blue.DEFAULT,
  [EnrollmentActionTypeEnum.VALIDATE_CSE]: tailwindColors.green.DEFAULT,
  [EnrollmentActionTypeEnum.REJECT_CSE]: tailwindColors.red.DEFAULT
}
